import React from "react";
import { Row, Col, Form, InputNumber } from "antd";

import Service from "./service";
import colors from "../../../colors";
import CustomIcon from "../../app/generic/customIcon";

const { Item } = Form;

const ServiceWithNumber = ({
  getFieldDecorator,
  serviceFieldName,
  numberFieldName,
  onServiceChange,
  disabledService,
  numberMessage,
  onInputChange,
  onValidation,
  serviceLabel,
  initialValue,
  numberLabel,
  showNumber,
  disabled,
  warning,
  min,
  max,
}) => (
  <Row>
    <Service
      hideRow
      label={serviceLabel}
      onChange={onServiceChange}
      initialValue={initialValue}
      fieldName={serviceFieldName}
      getFieldDecorator={getFieldDecorator}
      disabled={disabled || disabledService}
    />
    <Col span={16}>
      {showNumber && (
        <Item label={numberLabel}>
          {getFieldDecorator(numberFieldName, {
            initialValue: initialValue === 0 ? 1 : initialValue,
            rules: [
              {
                required: true,
                message: numberMessage,
              },
              { validator: onValidation },
            ],
          })(
            <InputNumber
              precision={0}
              min={min || 1}
              max={max || 25}
              disabled={disabled}
              onChange={onInputChange}
            />
          )}
          {warning && (
            <CustomIcon
              type="warning"
              marginLeft={10}
              title={warning}
              color={colors.RED}
            />
          )}
        </Item>
      )}
    </Col>
  </Row>
);

export default ServiceWithNumber;
